
import React, { useState, useEffect, useContext } from 'react';
import {
    Box,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    OutlinedInput,
    ListItemText, TextField, IconButton, Button, Tooltip,
    Radio,
    Grid
} from '@mui/material';
import CommonAccordion from "../../custom-components/CommonAccordion";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import { ReactComponent as UploadIcon } from "../../../images/uploadIcon.svg"
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ExportAuto } from "../../../images/exportAuto.svg";
import CloseIcon from '@mui/icons-material/Close';
import JiraProjectsComponentPage from '../../common-components/JiraProjectsComponentPage';
import mammoth from 'mammoth';
import { convertFreeFlowTextToUserStory, generateFSD, keyWordDesign, midLevelKeyWordDesign } from '../../../services/webServices';
import CodeEditor from './CodeEditor';
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import CommonDownload from '../../custom-components/CommonDownload';
import ALMConnectionPage from '../../main-pages/input-pages/ALMConnection/ALMConnectionPage';
import CommonCopy from "../../custom-components/CommonCopy";
import MessagePopup from '../../popup-components/MessagePopup';
import { use } from 'react';
import { is } from 'date-fns/locale';



const KeywordDesign = ({ keywordDesignData, projectType, keywordNextButton }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [downloadOpen, setDownloadOpen] = useState(false);
    const [personName, setPersonName] = useState([]);
    const [isTextEntered, setIsTextEntered] = useState("");
    const [isSpecUploaded, setIsSpecUploaded] = useState(false);
    const [isFsdUploaded, setIsFsdUploaded] = useState("");
    const [isStoriesUploaded, setIsStoriesUploaded] = useState(false);
    const [userStoriesData, setUserStoriesData] = useState([] || '');
    const [isCopied, setIsCopied] = useState(false);
    const { setLoadingState } = useContext(LoadingModalContext);
    const [keywordDesign, setKeywordDesign] = useState("");
    const nextButton = keywordNextButton ? [keywordNextButton] : [];

    const keyWordDesignCodeEditorData = location.state?.keywordDesignData;


    //  const defaultKeyWordDesignExpanded = Object.keys(keywordDesignData).length > 0 && (!keyWordDesignCodeEditorData || keyWordDesignCodeEditorData === '');
    let defaultKeyWordDesignExpanded = false;

    if (projectType === "newproject") {
        defaultKeyWordDesignExpanded =
            (!!location.state.keywordDesignData && location.state.keywordDesignData !== "") && !(!!location.state.midLevelKeywordsData && location.state.midLevelKeywordsData !== "")
    }

    if (projectType === "new-userstory") {
        defaultKeyWordDesignExpanded =
            Object.keys(keywordDesignData).length === 0 &&
            (!keyWordDesignCodeEditorData || keyWordDesignCodeEditorData === '');
    }


    const handleDownloadClick = () => {
        setDownloadOpen(true);
    };

    // const handleInputTextChange = (event) => {
    //     setIsTextEntered(event.target.value);
    // }

    const isAnyOptionSelected = personName.length > 0;
    const handleChange = (event) => {
        const { target: { value } } = event;
        setPersonName(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const isButtonEnabled = isTextEntered || isSpecUploaded || isStoriesUploaded;
    const [keywordoutputFS, setkeywordoutputFS] = useState(keyWordDesignCodeEditorData || "");
    const [keywordinputFS, setkeywordinputFS] = useState("");
    const [activeThumb, setActiveThumb] = useState(null);
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [sessionExpiredValue, setSessionExpiredValue] = useState(false);
    const [loading, setLoading] = useState(false);


    const handleCloseDownload = () => {
        setDownloadOpen(false);
    }

    const handleThumbClick = (thumbType) => {
        setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
    };

    const handleCopyClick = () => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
    };




    return (
        <>
            <Box>
                <CommonAccordion
                    summary={"High-Level Keywords"}
                    details={
                        <>
                            {Object.entries(keywordoutputFS).length > 0 && <CodeEditor codeContent={keywordoutputFS} setCodeContent={setkeywordoutputFS}

                            />}
                            {Object.entries(keywordoutputFS).length > 0 &&
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, mt: 2 }}>
                                    <Tooltip title="Like" arrow>
                                        <Box
                                            onClick={() => handleThumbClick("like")}
                                            sx={{
                                                cursor: "pointer",
                                                marginRight: 2,
                                                "&:hover": { color: "#49A3FF" },
                                            }}
                                        >
                                            {activeThumb === "like" ? (
                                                <ThumbUpIcon sx={{ fontSize: "24px" }} />
                                            ) : (
                                                <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} />
                                            )}
                                        </Box>
                                    </Tooltip>

                                    <Tooltip title="Dislike" arrow>
                                        <Box
                                            onClick={() => handleThumbClick("dislike")}
                                            sx={{
                                                cursor: "pointer",
                                                marginRight: 2,
                                                "&:hover": { color: "#FF4842" },
                                            }}
                                        >
                                            {activeThumb === "dislike" ? (
                                                <ThumbDownIcon sx={{ fontSize: "24px" }} />
                                            ) : (
                                                <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} />
                                            )}
                                        </Box>
                                    </Tooltip>
                                    <CommonCopy contentToCopy={keywordoutputFS} />

                                    {/* <Tooltip title={isCopied ? "Copied!" : "Copy"} arrow>
                                        <Box
                                            onClick={handleCopyClick}
                                            sx={{
                                                cursor: "pointer",
                                                "&:hover": { color: "#49A3FF" },
                                            }}
                                        >
                                            {isCopied ? (
                                                <ContentCopyIcon sx={{ fontSize: "24px" }} />
                                            ) : (
                                                <ContentCopyOutlinedIcon sx={{ fontSize: "24px" }} />
                                            )}
                                        </Box>
                                    </Tooltip> */}
                                </Box>
                            }
                        </>


                    }
                    buttons={
                        [
                            Object.entries(keywordoutputFS).length > 0 && {
                                label: "Download",
                                variant: "text",
                                onClick: handleDownloadClick,
                                startIcon: <SaveAltRoundedIcon />,
                                sx: { float: "left" }
                            },
                            ...nextButton,
                            // {
                            //     label: "Prompts",
                            //     variant: "contained",
                            //     onClick: handlePromptsPopup,
                            //     startIcon: <GenerateButton />,
                            // }
                        ]}
                    type={"output"}
                    fullScreenMode={true}
                    defaultExpanded={defaultKeyWordDesignExpanded}


                />
                <MessagePopup
                    modalOpen={popupOpen}
                    okayHandler={() => setPopupOpen(false)}
                    message={popupMessage}
                />
                <CommonDownload open={downloadOpen}
                    onClose={handleCloseDownload}
                    serviceResponse={[{ heading: "keyword Design", type: "text", data: keywordoutputFS }]}
                    serviceName="Keyword design"
                    wordData={[{ heading: "keyword Design", type: "text", data: keywordoutputFS }]}
                    documents={['docx']}

                />
            </Box>
        </>

    );
};

export default KeywordDesign;



